const appointmentForm = {
  /**
   * Appointment form key
   * @type {String}
   */
  key: "appointmentForm",

  /**
   * Appointment form fields object
   * @type {Object}
   */
  fields: {
    // type: "REGULAR",
    // serviceId: null,
    // clientId: null,
    // clientIds: [],
    subjectId: null,
    calendarId: null,
    date: null,
    from: null,
    duration: null,
    notes: "",
    document: null,
  },

  /**
   * Appointment form errors object
   * @type {Object}
   */
  errors: {},

  /**
   * Appointment form mode
   * @type {String}
   */
  mode: "create",

  /**
   * Appointment form path
   * @type {String}
   */
  path: "/api/b2b/appointments",

  /**
   * Appointment form helpers
   * @type {Object}
   */
  helpers: {
    subjectOptions: [],
  }
};

export default appointmentForm;
